import StoreHierarchyWidget from '../../../components/hierarchy_fields/StoreHierarchyWidget.jsx';
import InlineComponent from './inlineComponent.jsx';

module.exports = class storeHierarchyWidget extends InlineComponent {
  define() {
    this.component = StoreHierarchyWidget;
  }
};
